import React, { useState } from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby"
import "assets/css/accordion.css"

const LinkList = styled.li`
    list-style: none;
    padding: 0;
    margin: 0;
`
const MenuLink = styled(Link)`
    &,
    &:hover,
    &:visited {
        display: flex;
        text-decoration: none;
        padding: 16px 32px 16px 16px;
        text-transform: uppercase;
        font-weight: normal;
        color: ${(props) => props.theme.colors.secondary};
        font-size: 17px;
        align-items: center;
        justify-content: space-between;
        background: #f7f7f7;
    }

    &:active,
    &:hover {
        color: ${(props) => props.theme.colors.background};
        background: ${(props) => props.theme.colors.blue1};
    }
`

const MobileSubmenu = (props) => {
    const [setActive, setActiveState] = useState("")
    const { linkItem } = props
    const toggleAccordion = () => {
        setActiveState("active")
    }

    return (
        <>
            <LinkList key={linkItem.id} onClick={toggleAccordion}>
                {linkItem.submenu && linkItem.submenu.length > 0 ? (
                    linkItem.submenu.map((subLink) =>
                        subLink.childmenu.map((childMenu, index) => (
                            <MenuLink
                                key={index}
                                to={`${subLink.link}/${childMenu.link}`}
                            >
                                {childMenu.name}
                            </MenuLink>
                        ))
                    )
                ) : (
                    <MenuLink
                        id={linkItem.id}
                        to={
                            linkItem.submenu && linkItem.submenu.length > 0
                                ? "#"
                                : linkItem.url
                        }
                    >
                        {linkItem.displayname || linkItem.name}
                    </MenuLink>
                )}
            </LinkList>
            {/* {linkItem.submenu && linkItem.submenu.length > 0 ? (
                <Submenu className={setActive}>
                    <BackButton>
                        <Button
                            variant="buttons.mobile"
                            sx={{
                                backgroundColor: "#F7F7F7",
                                color: "blue1",
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                            }}
                            onClick={toggleBack}
                        >
                            <span className={componentStyle.iconsSmall}>
                                <FiArrowLeft />{" "}
                            </span>{" "}
                            &nbsp;BACK
                        </Button>
                    </BackButton>
                    <MenuHeader>
                        {linkItem.displayname || linkItem.name}
                    </MenuHeader>
                    <ul>
                        {linkItem.submenu.map((subLink) =>
                            subLink.childmenu.map((childMenu, index) => (
                                <MenuLink
                                    key={index}
                                    to={`${subLink.link}/${childMenu.link}`}
                                >
                                    {childMenu.name}
                                </MenuLink>
                            ))
                        )}
                    </ul>
                </Submenu>
            ) : null} */}
        </>
    )
}

export default MobileSubmenu
